import { render, staticRenderFns } from "./LearnPlatform.vue?vue&type=template&id=52c11956&scoped=true"
import script from "./LearnPlatform.vue?vue&type=script&lang=js"
export * from "./LearnPlatform.vue?vue&type=script&lang=js"
import style0 from "./LearnPlatform.vue?vue&type=style&index=0&id=52c11956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c11956",
  null
  
)

export default component.exports